import { PENDO_TOKEN } from '../config/environment';

function initializePendo() {
  if (import.meta.env.VITE_DISABLE_VENDORS === 'true') return;
  const existingScript = document.getElementById('pendoScript');
  if (existingScript) return;
  const script = document.createElement('script');
  script.id = 'pendoScript';
  document.body.appendChild(script);

  ((apiKey: string) => {
    ((p: any, e: Document, n: string, d: string) => {
      const o = (p[d] = p[d] || {});
      o._q = o._q || [];
      const v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track'];
      for (let w = 0, x = v.length; w < x; ++w) {
        ((m: string) => {
          o[m] =
            o[m] ||
            function (...args: unknown[]) {
              const method = m === v[0] ? 'unshift' : 'push';
              o._q[method]([m, ...args]);
            };
        })(v[w]);
      }
      const y = e.createElement(n) as HTMLScriptElement;
      y.async = true;
      y.src = `https://content.pendo.6sense.com/agent/static/${apiKey}/pendo.js`;
      const z = e.getElementsByTagName(n)[0];
      z.parentNode!.insertBefore(y, z);
    })(window, document, 'script', 'pendo');
  })(PENDO_TOKEN);
}

export default initializePendo;
